import type { DiscussionAudienceGroup, StudioGroup, UserRole } from './users';

export interface PersonalDiscussionAudience {
  audienceRoles?: readonly UserRole[];
  audienceGroups?: readonly DiscussionAudienceGroup[];
}

/**
 * Whether this announcement belongs on THIS person's own Messages list.
 *
 * `onJrStaffRoll` is the caller's membership of the Jr Staff board's derived
 * roll. A parent standing in for a Jr Staff dancer belongs on the list of an
 * announcement addressed to Jr Staff, and on no other announcement - the
 * boundary itself is jrStaffAudienceCoversRollCaller in
 * shared/firestore.rules; this only decides what the screen offers to show.
 */
export function discussionBelongsInPersonalInbox(
  discussion: PersonalDiscussionAudience,
  role: UserRole,
  groups: readonly StudioGroup[] = [],
  onJrStaffRoll = false
): boolean {
  const audienceRoles = discussion.audienceRoles ?? [];
  const audienceGroups = discussion.audienceGroups ?? [];
  if (onJrStaffRoll && audienceGroups.includes('jrStaff')) return true;
  // An empty audienceRoles means every active staff member, whether or not a
  // named group rides alongside it (a 'jrStaff' group widens that audience
  // rather than narrowing it). The only group that could ever ride here
  // before 2026-08-30 was 'interns', which always carries a NON-empty
  // audienceRoles, so this reads the same on every older announcement.
  if (audienceRoles.length === 0) return true;
  if (audienceRoles.includes(role)) return true;
  return audienceGroups.some((group) => (groups as readonly string[]).includes(group));
}
